import React, { useRef, useState } from 'react';

import { Box, ScrollArea, ScrollAreaProps } from '@mantine/core';
import { Virtuoso } from 'react-virtuoso';

interface VirtualListScrollAreaProps extends ScrollAreaProps {
  items: Array<React.ReactNode>;
  loadingItem?: React.ReactNode;
}

export function VirtualListScrollArea({ items, loadingItem, ...scrollAreaProps }: VirtualListScrollAreaProps) {
  const [isScrolling, setIsScrolling] = useState(false);
  const scrollAreaRef = useRef<HTMLDivElement>(null);

  return (
    <ScrollArea viewportRef={scrollAreaRef} {...scrollAreaProps}>
      <Virtuoso
        useWindowScroll={false}
        data={items}
        isScrolling={(value) => loadingItem && setIsScrolling(value)}
        customScrollParent={scrollAreaRef.current ? scrollAreaRef.current : undefined}
        itemContent={(index, item) => {
          return <Box key={index}>{isScrolling && loadingItem ? loadingItem : item}</Box>;
        }}
      />
    </ScrollArea>
  );
}
